import { Spinner } from "@/components/ui/spinner";

/**
 * The Suspense fallback for lazily-loaded route content — the "Loading
 * Boundary" wrapping `<Outlet />` in `AppLayout`. Composes the shared
 * `Spinner` primitive's full-view size rather than duplicating its
 * role/label wiring.
 */
export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Spinner size="full-view" />
    </div>
  );
}
